import Vue from 'vue';
import Vuex from 'vuex';

import mylink from './mylink/index';
import site from './modules/site';
import siteMapping from './modules/siteMapping';
import department from './modules/department';
import role from './modules/role';

import ttAccount from './modules/masterData/tt-account';
import budgetItem from './modules/masterData/budget-item';
import opexGL from './modules/masterData/opex-gl';
import capexGL from './modules/masterData/capex-gl';
import fundCenter from './modules/masterData/fund-center';
import fund from './modules/masterData/fund';
import imNumber from './modules/masterData/im-number';
import user from './modules/masterData/user';
import masterRole from './modules/masterData/master-role';
import masterOrgChart from './modules/masterData/master-org-chart';
import projectTag from './modules/projectTag';

import budgetPlan from './modules/budget_plan';
import budgetMonitor from './modules/budget_monitor';
import compared from './modules/compares';
import taskTransfer from './modules/task_transfer';

import history from './modules/history_budget';

import expanses from './modules/expanses';
import reportExcel from './modules/report_excel';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		mylink,
		site,
		siteMapping,
		department,
		ttAccount,
		budgetItem,
		capexGL,
		opexGL,
		fundCenter,
		fund,
		budgetPlan,
		budgetMonitor,
		compared,
		role,
		imNumber,
		history,
		expanses,
		user,
		masterRole,
		masterOrgChart,
		reportExcel,
		taskTransfer,
		projectTag,
	},
});
